// Zentrale App-Version
// HIER die Version ändern, sie wird automatisch überall aktualisiert
export const APP_VERSION = '1.22.3';

